import { useState } from "react";

export const useResetEmail = () => {
  const [emailError, setEmailError] = useState(null);
  const resetEmail = async (email) => {
    try {
      
      const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/user/resetEmail", {
        method: "POST",
        body: JSON.stringify({ email }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      if (!response.ok) {
        setEmailError(json.error);
      }
      if (response.ok) {
        setEmailError(json.message);
      }
    } catch (error) {
      setEmailError("An error occurred, please try again");
      console.error(error);
    }
  };
  return { resetEmail, emailError };
};
